import { Table, Form } from "react-bootstrap";
import { Tooltip_detail as Tooltip } from "../helpers/Tooltip";
import Error from "../../../../icons/ErrorIcon.svg";

import { SearchSelect } from "../../forms/inputs/search-select";
import { TypeData, LayerData } from "./TransactionEntity";
import { Action } from "../constants/CommonConstants";
import PropTypes from 'prop-types';
import { useLocation } from "react-router-dom";

export const ProcessTypeTable = ({
  detailObj,
  setdetailObj,
  ProcessActive,
  fieldPrefix = "WPQ", // "WPQ" or "PQR"
  showLayer = false,
  onProcessChange,
  isReadonly,
  disableFields,
  className = "WPQSelect",
  customHeaderStyle,
  // New props for checkbox functionality
  handleProcessCheckboxChange
}) => {
  ProcessTypeTable.propTypes = {
    detailObj: PropTypes.array,
    setdetailObj: PropTypes.func,
    ProcessActive: PropTypes.array,
    fieldPrefix: PropTypes.string,
    showLayer: PropTypes.bool,
    onProcessChange: PropTypes.func,
    isReadonly: PropTypes.bool,
    disableFields: PropTypes.bool,
    className: PropTypes.string,
    customHeaderStyle: PropTypes.string,
    handleProcessCheckboxChange: PropTypes.func
  };

  const location = useLocation();
  const actionFromLocation = location.state?.action;
  const currentAction = actionFromLocation;

  const processField = `${fieldPrefix}_Process`;
  const typeField = `${fieldPrefix}_Type`;
  const layerField = `${fieldPrefix}_Layer`;
  const categoryField = `${fieldPrefix}_Process_Category`;

  // Check if we should show checkboxes (only for PQR)
  const showCheckboxes = fieldPrefix === "PQR" && handleProcessCheckboxChange;

  return (
    <Table className="text-center tablewidth">
      <thead>
        <tr className="border thead-color">
          <th className="thickness_title" style={{ width: "21%" }}></th>
          <th className={`${customHeaderStyle || 'thickness_title'}`} style={{ width: "19%" }}>Process</th>
          <th className={`${customHeaderStyle || 'thickness_title'}`} style={{ width: "19%" }}>Type</th>
          {showLayer ? (
            <th className={`${customHeaderStyle || 'thickness_title'}`} style={{ width: "19%" }}>Layer</th>
          ) : (
            <th className="thickness_title"></th>
          )}
          {showCheckboxes && (
            <th className={`${customHeaderStyle || 'thickness_title'}`} style={{ width: "15%" }}>Show in Report</th>
          )}
          <th className="thickness_title"></th>
          <th className="thickness_title"></th>
          <th className="thickness_title"></th>
        </tr>
      </thead>
      <tbody>
        {detailObj?.map((item, i) => {
          const isProcessActive = item?.[processField] && item?.[processField] !== "" && item?.[processField] !== "NA";
          
          return (
            <tr key={i} className={detailObj[i]?.error ? "border error" : "border"}>
              <th
                className={
                  detailObj[i]?.error
                    ? "text-start border thead-color error-head"
                    : "text-start border thead-color"
                }
              >
                <div>
                  <Form.Label>Process {i + 1}</Form.Label>
                  {detailObj[i]?.error && (
                    <Tooltip content={detailObj[i]?.errormessage}>
                      <img src={Error} alt="Error" className="ms-1" />
                    </Tooltip>
                  )}
                </div>
              </th>
              <td className={className} style={{ paddingLeft: "2%" }}>
                <SearchSelect
                  className="inspdrop"
                  data={ProcessActive}
                  valueField={"wld_code"}
                  disabled={disableFields}
                  readOnly={currentAction === Action.ActionCopy || currentAction === Action.ActionEdit ? isReadonly : false}
                  placeholder=""
                  value={item?.[processField]}
                  labelField={"wld_code"}
                  onChange={(e) => {
                    let a = ProcessActive.filter((b) => b.wld_code === e.value);
                    let c = a[0];
                    item[processField] = e.value;
                    item[categoryField] = c?.wld_p_category;
                    if (e.value === "NA") {
                      item[processField] = "";
                      item[typeField] = "";
                      if (showLayer) item[layerField] = "";
                    }
                    // Call parent handler for special logic (like deletion)
                    if (onProcessChange) {
                      onProcessChange(e.value, i, item);
                    }
                    setdetailObj([...detailObj]);
                  }}
                />
              </td>
              <td className={className} style={{ paddingLeft: "2%" }}>
                <SearchSelect
                  data={TypeData}
                  readOnly={currentAction === Action.ActionCopy ? isReadonly : false}
                  valueField={"wld_type"}
                  disabled={disableFields}
                  value={item?.[typeField]}
                  labelField={"wld_type"}
                  placeholder=""
                  onChange={(e) => {
                    item[typeField] = e.value;
                    setdetailObj([...detailObj]);
                    if (item[processField] !== "" || item[typeField] !== "") {
                      detailObj[i].error = false;
                    } else {
                      detailObj[i].error = true;
                    }

                    let a = ProcessActive.filter((b) => b.wld_code === item[processField]);
                    if (fieldPrefix === "WPQ") {
                      item[categoryField] = a[0]?.wld_p_category + "#" + e.value;
                    }
                  }}
                />
              </td>
              {showLayer ? (
                <td className={className} style={{ paddingLeft: "2%" }}>
                  <SearchSelect
                    data={LayerData}
                    readOnly={currentAction === Action.ActionCopy ? isReadonly : false}
                    valueField={"wld_layer"}
                    disabled={disableFields}
                    value={item?.[layerField]}
                    labelField={"wld_layer"}
                    placeholder=""
                    onChange={(e) => {
                      item[layerField] = e.value;
                      setdetailObj([...detailObj]);
                      if (item[processField] !== "" || item[layerField] !== "") {
                        detailObj[i].error = false;
                      } else {
                        detailObj[i].error = true;
                      }
                    }}
                  />
                </td>
              ) : (
                <td style={{ width: "39%" }}></td>
              )}
              {showCheckboxes && (
                <td className="text-center" style={{ paddingLeft: "2%" }}>
                  <div className="checkboxproject">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={`processCheckbox${i}`}
                      onChange={(e) => {
                        console.log(`Checkbox ${i} changed:`, {
                          checked: e.target.checked,
                          currentShowreport: item?.showreport,
                          booleanValue: Boolean(item?.showreport)
                        });
                        handleProcessCheckboxChange && handleProcessCheckboxChange(i, e.target.checked);
                      }}
                      checked={Boolean(item?.showreport)}
                      disabled={!isProcessActive || disableFields}
                      title={isProcessActive ? `Show ${item?.[processField]} in Report` : "Select a process first"}
                    />
                  </div>
                </td>
              )}
              <td></td>
              <td></td>
              <td></td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};